<template>
  <cellTooltip
    :items="checked"
    :template="'icon+text'"
    :group-by="'group'"
    :can-show="true"
    :icon-field="'picture'"
    :value-field="'name'"
  >
    <div
      :class="[$style.cell_trigger,
               disabled ? $style.disabled_cell :'' ,
               crossout && !isOpen ? $style.crossout :'',
               isOpen && editable ? $style.edit : '',
               !editable ? $style.not_allowed : '',
      ]"
      :style="{opacity: isOpen ? 1 : cellOpecity}"
      @click="clickOnCell"
    >
      <template v-if="checked.length">
        <template v-if="checked.length === 1">
          <div
            :style="{'background-image': `url(${checked[0].picture})`}"
            :class="[$style.icon_wrap]"
          />
          <span :class="[$style.text_wrap, $style.select_none]">{{ checked[0].name }}</span>
        </template>

        <template v-if="checked && checked.length > 1">
          <div
            v-for="index in 2"
            :key="'i+t_s-' + index "
            :style="{'background-image': `url(${checked[index-1].picture})`}"
            :class="[$style.icon_wrap]"
          />
          <span
            v-if="checked.length > 2"
            :class="[$style.select_none]"
          > +{{ checked.length - 2 }} </span>
        </template>
      </template>
      <span
        v-else
        :class="[$style.secondary, $style.text_wrap, $style.select_none]"
      > {{ local_noAsigned }} </span>
    </div>
  </cellTooltip>
</template>

<script>
import globalStore from '$$store/main';
import app from '$$app';
import cellTooltip from './tooltip.vue';

export default {
  name: 'ResourcesCell',
  components: { cellTooltip },
  props: {
    item: { type: Object, required: true },
    property: { type: [String, Number], required: true },
    disabled: { type: Boolean, required: false, default: false },
    editable: { type: Boolean, required: false, default: true },
    discolor: { type: Number, required: false, default: 1 },
    crossout: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      local_noAsigned: __('notAssigned'),
      isOpen: false,
      clickOnCurrentCell: false,
    };
  },
  computed: {
    cellOpecity() {
      const val = +this.discolor || 1;

      if (this.disabled && val !== 1) { return 0.8; }

      return val;
    },

    checked() {
      const taskResources = globalStore.getters['tasksModel/getResourcesForTask'](+this.item.gantt_id, +this.item.id);
      const allResources = _.cloneDeep(globalStore.getters['resourcesModel/getResourcesByProjectIdForUI'](+this.item.gantt_id));

      const checked = allResources.filter(resource => {
        const taskResource = taskResources.filter(res => res.resource_id === resource.id)[0];

        return !!taskResource;
      });

      return checked || [];
    },
  },

  mounted() {
    document.addEventListener('contextmenu', this.contextMenuEvent);
  },

  beforeUnmount() {
    this.hidePopup();
    document.removeEventListener('contextmenu', this.contextMenuEvent);
  },

  methods: {
    contextMenuEvent(e) {
      this.hidePopup();
    },

    clickOnCell(e) {
      if (this.disabled || !this.editable) {
        e.preventDefault();

        return;
      }

      this.clickOnCurrentCell = true;
      this.isOpen ? this.hidePopup() : this.openPopup();
    },

    hidePopup() {
      app.trigger('hideResourcesListForTask');
      this.clickOnCurrentCell = false;
    },

    openPopup() {
      const pos = this.$el.getBoundingClientRectWrapper();
      const component = this;

      app.trigger('showResourcesListForTask', pos, this.item.id, this.item.gantt_id, 'listView', () => {
        component.isOpen = false;
        component.clickOnCurrentCell = false;
      });
      this.clickOnCurrentCell && (this.isOpen = true);
    },
  },
};
</script>

<style module src="./cell.less" lang="less">
</style>
